export default {
    title: "Neuigkeiten",
    description: "Hier können Sie Neuigkeiten für Ihre Organisation / Ihren Verband bearbeiten.",
    content: "Inhalt",
    saveContent: "Speichern",
}